<template>
  <b-container fluid>
    <backlink/>
    <h1>Contacts</h1>

    <AdminTable :config="config" :options="options"></AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTable";
import config from "./config";

export default {
  name: "CompanyContactList",
  components: {
    AdminTable
  },
  data() {
    return {
      config: config
    };
  },
  computed: {
    options: function() {
      return {
        company_options: this.$store.getters["company/getAll"].selectOptions(
          "id",
          "name"
        )
      };
    }
  },
  mounted() {
    this.$store.dispatch("company/getAllForSelect");
  }
};
</script>


// WEBPACK FOOTER //
// src/components/CompanyContact/CompanyContactList.vue